// extracted by mini-css-extract-plugin
export default {"melodyVideo":"yK-z","isFullWidth":"zK-z","landingPageVideo":"AK-z","play":"BK-z","iframeVideo":"CK-z","playHidden":"DK-z","fullwidth":"EK-z"};